import React from 'react';
import PropTypes from 'prop-types';
import FormattedListValue from '@/shared/components/FormattedListValue';
import SimplePanel from '@/shared/components/SimplePanel';
import { FormattedMessage } from 'react-intl';
import { FaExternalLinkAlt } from 'react-icons/fa';
import messages from '../jobMessages';
import { CanRead } from '@/shared/components/security';
import { injectStateService, StateService } from '@/shared/services/StateService';

const JobDetailMailInvoices = ({ job, stateService }) => (
  <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
    <div className="info-block container-fluid radius4B">
      <div className="row">
        <div className="col-lg-6">
          <div className="row">
            <div className="col-md-5 col-sm-6">
              <label>
                <b>
                  <FormattedMessage {...messages.MailTemplate} />
                </b>
              </label>
            </div>
            <div className="col-md-7 col-sm-6">
              <FormattedListValue list="template" id={job.parameters.templateId} />
              <CanRead on="Settings">
                <a
                  onClick={() =>
                    stateService.gotoState('settings.templates.edit', {
                      templateId: job.parameters.templateId,
                    })
                  }
                >
                  <FaExternalLinkAlt />
                </a>
              </CanRead>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SimplePanel>
);

JobDetailMailInvoices.propTypes = {
  job: PropTypes.shape({}).isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
};

export default injectStateService(JobDetailMailInvoices);
